import React, { useState, useRef, useEffect } from 'react';
import './style.scss';

export const QRLinkingInput = ({
  hasError = false,
  setCode,
  setHasError,
  code,
}) => {
  const inputRefs = useRef([]);
  const [focusedIndex, setFocusedIndex] = useState(null);

  useEffect(() => {
    if (inputRefs.current[0]) {
      inputRefs.current[0].focus();
    }
  }, []);

  const handleChange = (index, value) => {
    if (value && !/^[a-zA-Z0-9]$/.test(value)) {
      return;
    }
    setHasError(false);
    const newValues = [...code];
    newValues[index] = value;
    setCode(newValues);
    if (value && index < 5) {
      inputRefs.current[index + 1]?.focus();
    }
  };

  const handleKeyDown = (index, e) => {
    if (e.key === 'Backspace' && !code[index] && index > 0) {
      inputRefs.current[index - 1]?.focus();
    }
  };

  const handlePaste = e => {
    e.preventDefault();
    const pastedData = e.clipboardData.getData('text');
    const chars = pastedData
      .replace(/[^a-zA-Z0-9]/g, '')
      .slice(0, 6)
      .split('');

    const newValues = [...code];
    chars.forEach((char, i) => {
      if (i < 6) {
        newValues[i] = char;
      }
    });
    setCode(newValues);

    const nextEmptyIndex = newValues.findIndex(val => !val);
    const focusIndex = nextEmptyIndex === -1 ? 5 : Math.min(nextEmptyIndex, 5);
    inputRefs.current[focusIndex]?.focus();
  };

  useEffect(
    () => {
      if (code.join('') === '' && inputRefs.current[0]) {
        inputRefs.current[0].focus();
      }
    },
    [code],
  );

  return (
    <div className="qr-linking-input">
      {code.map((value, index) => (
        <div
          key={index}
          className={`qr-linking-input__wrapper ${
            focusedIndex === index && !value ? 'show-underscore' : ''
          }`}
        >
          <input
            name={`qr-linking-input-${index}`}
            ref={el => (inputRefs.current[index] = el)}
            type="text"
            inputMode="text"
            maxLength={1}
            value={value}
            onChange={e => handleChange(index, e.target.value)}
            onKeyDown={e => handleKeyDown(index, e)}
            onPaste={handlePaste}
            onFocus={() => setFocusedIndex(index)}
            onBlur={() => setFocusedIndex(null)}
            className={`qr-linking-input__field ${hasError ? 'otp-error' : ''}`}
            autoComplete="off"
          />
        </div>
      ))}
    </div>
  );
};
